(function (angular) {
    angular
        .module('one.admin')
        .controller('SiteStylesController', SiteStylesController);

    SiteStylesController.$inject = ['$scope', '$timeout', 'notification', 'session', 'modal', 'translateFilter', 'SiteService', 'FormHelper'];

    function SiteStylesController($scope, $timeout, notification, session, modal, translateFilter, SiteService, FormHelper) {
        $scope.site = angular.copy(session.get('data.current_site'));
        $scope.site.logo = $scope.site.logo || null;
        $scope.site.inverse_logo = $scope.site.inverse_logo || null;

        $scope.variables = [];

        angular.forEach($scope.site.config_keys.brands, function (brand) {
            $scope.variables.push('brand.' + brand);
        });

        $scope.logoForm = FormHelper.getFormState({
            data: {
                logo: $scope.site.logo,
                inverse_logo: $scope.site.inverse_logo
            },
            submit: function (data) {
                data = angular.merge({ id: $scope.site.id }, data);

                return SiteService.editSite(data);
            },
            success: updateSessionOnSave
        });

        $scope.headerForm = FormHelper.getFormState({
            data: $scope.site.config.header_bar,
            submit: function (data) {
                data = angular.merge({ id: $scope.site.id }, {
                    config: {
                        header_bar: data
                    }
                });

                return SiteService.updateConfig(data);
            },
            success: updateSessionOnSave
        });

        $scope.footerForm = FormHelper.getFormState({
            data: $scope.site.config.footer_bar,
            submit: function (data) {
                data = angular.merge({ id: $scope.site.id }, {
                    config: {
                        footer_bar: data
                    }
                });

                return SiteService.updateConfig(data);
            },
            success: updateSessionOnSave
        });

        function updateSessionOnSave(data) {
            $scope.site = data.site;
            session.set('data.current_site', angular.copy(data.site));
        }

        $scope.openAuditorModal = openAuditorModal;

        function openAuditorModal() {
            modal.open('auditor', 'lg', { modelId: $scope.site.id, modelType: 'site' });
        }
    }
})(angular);
